import React from 'react';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import ConfigurationsTable from './ConfigurationsTable';

import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './ConfigurationPage.module.css';

const ConfigurationPage = ({
    activeNavCompany,
    history,
    ...props
}) => {

    let hasReturnUrl = false;

    if (history.location.search && history.location.state && history.location.state.returnUrl) {
        hasReturnUrl = true;
    }

    const handleBackClick = () => {
        if (hasReturnUrl) {
            history.push({
                pathname: history.location.state.returnUrl,
                search:   `?${history.location.search}`
            });
        }
    };

    return (
        <BobPage className={classes.OverrideMargin}>
            <div className={classes.ConfigurationPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.TitlePanel}>
                        <div className={classes.Name}>
                            <span>
                                {
                                    hasReturnUrl ?
                                        <span
                                            className={classes.BackIcon}
                                            aria-hidden="true"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() =>
                                                handleBackClick()
                                            }
                                        >
                                            <i className="fas fa-chevron-left" />
                                        </span>
                                        : ''
                                }
                                { 'My Views & Configurations' }
                            </span> 
                        </div>
                    </div>
                </div>
                <div className={classes.TablePanel}>
                    <ConfigurationsTable />
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigurationPage));
